import {
    REGISTER_TRIAL_USER,
    REGISTER_TRIAL_USER_SUCCESSFUL,
    REGISTER_TRIAL_USER_FAILED,
    SET_MESSAGE,
    CLEAR_MESSAGE,
    GET_NEW_TRIAL_USER,
    SEND_REGISTER_TRIAL_USER_EMAIL,
    GET_TRIAL_USER_SUCCESSFUL,
    GET_TRIAL_USER_FAILED, UPDATE_TRIAL_USER, UPDATE_TRIAL_USER_SUCCESSFUL,
    DELETE_TRIAL_USER,
    DELETE_TRIAL_USER_SUCCESSFUL,
    DELETE_TRIAL_USER_FAILED
} from './actionTypes';
import {UPDATE_NEW_TRIAL_USER} from "../../helpers/url_helper";
// import {GET_NEW_TRIAL_USER} from "../../../helpers/url_helper";

export const registerTrialUser = (user) => {
    return {
        type: REGISTER_TRIAL_USER,
        payload: { user },
    };
};

export const registerTrialUserSuccessful = (user) => {
    return {
        type: REGISTER_TRIAL_USER_SUCCESSFUL,
        payload: user,
    };
};

export const registerTrialUserFailed = (error) => {
    return {
        type: REGISTER_TRIAL_USER_FAILED,
        payload: error,
    };
};

export const setMessage = (message) => ({
    type: SET_MESSAGE,
    payload: message,
});

export const clearMessage = () => ({ type: CLEAR_MESSAGE });

export const getTrialUser = (user) => {
    console.log("hello again");
    return {
        type: GET_NEW_TRIAL_USER,
        payload: { user }
    }
}

export const setRegisterTrailUserEmail = (user) => {
    console.log('--== handleOnRequestForDemo ', user);
    return {
        type: SEND_REGISTER_TRIAL_USER_EMAIL,
        payload: { user }
    }
}

export const getTrialUserSuccessful = (user) => {
    console.log("hello");
    return {
        type: GET_TRIAL_USER_SUCCESSFUL,
        payload: { user },
    };
};

export const getTrialUserFailed = (error) => {
    return {
        type: GET_TRIAL_USER_FAILED,
        payload: error,
    };
};

export const updateTrialUser = (user) => {
    return {
        type: UPDATE_TRIAL_USER,
        payload: { user },
    };
};

export const updateTrialUserSuccessful = (user) => {
    return {
        type: UPDATE_TRIAL_USER_SUCCESSFUL,
        payload: { user },
    };
};

export const deleteTrialUser = (user) => {
    return {
        type: DELETE_TRIAL_USER,
        payload: { user },
    };
};

export const deleteTrialUserSuccessful = (user) => {
    return {
        type: DELETE_TRIAL_USER_SUCCESSFUL,
        payload: { user },
    };
};

export const deleteTrialUserFailed = (user) => {
    return {
        type: DELETE_TRIAL_USER_FAILED,
        payload: { user },
    };
};


